'use client';

import { FC } from 'react';

import { Analytics } from '../Analytics/Analytics';
import { ScrollWatcher } from '../ScrollWatcher/ScrollWatcher';
import { ToasterContainer } from '../ToasterContainer/ToasterContainer';
import { WebVitals } from '../WebVitals/WebVitals';
import { WebsiteGlobals } from '../WebsiteGlobals/WebsiteGlobals';

/**
 * Load Website helpers such as mini-CDP, Website globals, scroll watcher
 */
export const WebsiteHelpers: FC = () => (
  <>
    <WebVitals />
    <Analytics />
    <WebsiteGlobals />
    <ScrollWatcher />
    <ToasterContainer />
  </>
);
